<template>
  <CModal
    :title="title"
    :show="show"
    size="lg"
    :closeOnBackdrop="false"
    @update:show="(v) => { if (!v) $emit('close'); }"
  >
    <CRow>
      <CCol
        v-for="(f, i) in fields"
        :key="f.key"
        :md="f.full ? 12 : 6"
      >
        <CSelect
          v-if="f.type === 'select' || f.type === 'enum'"
          :label="labelFor(f, i)"
          :options="f.options"
          :value="local[f.key]"
          @update:value="(val) => onSelect(f, val)"
        />
        <CTextarea
          v-else-if="f.type === 'textarea'"
          :label="labelFor(f, i)"
          :rows="2"
          :placeholder="f.placeholder"
          v-model="local[f.key]"
        />
        <CInput
          v-else
          :label="labelFor(f, i)"
          :type="f.type || 'text'"
          :step="f.type === 'number' ? 'any' : undefined"
          :inputmode="f.type === 'number' ? 'decimal' : undefined"
          :placeholder="f.placeholder"
          v-model="local[f.key]"
        />
      </CCol>
    </CRow>

    <template #footer>
      <CButton color="light" @click="$emit('close')">Cancel</CButton>
      <CButton color="primary" :disabled="!isValid" @click="save">
        {{ local.id ? 'Save' : 'Add' }}
      </CButton>
    </template>
  </CModal>
</template>

<script>
import { asDateString } from "@/utils/datetime";

export default {
  name: "PlannerFormModal",
  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: "" },
    fields: { type: Array, default: () => [] },
    item: { type: Object, default: () => ({}) },
  },
  data() {
    return { local: {} };
  },
  computed: {
    isValid() {
      const first = this.fields[0];
      if (!first) return true;
      const v = this.local[first.key];
      return v !== undefined && v !== null && String(v).trim().length > 0;
    },
  },
  watch: {
    show(open) {
      if (open) this.populate();
    },
  },
  methods: {
    // The first field is the only required one (see isValid).
    labelFor(f, index) {
      return index === 0 ? `${f.label} *` : f.label;
    },
    populate() {
      const obj = { ...this.item };
      this.fields.forEach((f) => {
        if (obj[f.key] === undefined || obj[f.key] === null) {
          obj[f.key] = f.type === "enum" ? (f.options[0] && f.options[0].value) : "";
        }
        // Normalise date fields to YYYY-MM-DD for the native date input
        if (f.type === "date" && obj[f.key]) {
          obj[f.key] = asDateString(obj[f.key]);
        }
      });
      this.local = obj;
    },
    onSelect(f, val) {
      this.$set(this.local, f.key, f.type === "enum" ? Number(val) : val);
    },
    save() {
      if (!this.isValid) return;
      const payload = { ...this.local };
      this.fields.forEach((f) => {
        if (f.type === "number") payload[f.key] = Number(payload[f.key]) || 0;
        if (f.type === "enum") payload[f.key] = Number(payload[f.key]) || 0;
        if (f.type === "date" && !payload[f.key]) payload[f.key] = null;
      });
      this.$emit("save", payload);
    },
  },
};
</script>
